import { IUserFull } from '@gettactic/api';
import { api } from '@/lib/api/api';
import {
  useFavs as useBaseFavs,
  useDefaultGroupMembers as useBaseDefaultGroupMembers
} from '@gettactic/hooks';
import { createApiWrapper } from '@gettactic/helpers';
import toast from 'react-hot-toast';
import React, { useState } from 'react';
import { usePopper } from 'react-popper';

export function useDefaultGroupMembers() {
  return useBaseDefaultGroupMembers(api);
}

export default function useFavs(
  user: IUserFull,
  issueSuccessMessage = (message: string) => toast.success(message)
) {
  const favsHook = useBaseFavs(user, api, issueSuccessMessage);

  const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(
    null
  );
  const [popperElement, setPopperElement] = useState<HTMLElement | null>(null);
  const [arrowElement, setArrowElement] = useState<HTMLElement | null>(null);

  const {
    styles,
    attributes,
    update: updatePopper
  } = usePopper(referenceElement, popperElement, {
    placement: 'left',
    modifiers: [{ name: 'arrow', options: { element: arrowElement } }]
  });

  const addUserToDefaultGroup = createApiWrapper(
    favsHook.addUserToDefaultGroup,
    api
  );
  const removeUserFromDefaultGroup = createApiWrapper(
    favsHook.removeUserFromDefaultGroup,
    api
  );
  const addUserToGroup = createApiWrapper(favsHook.addUserToGroup, api);
  const removeUserFromGroup = createApiWrapper(
    favsHook.removeUserFromGroup,
    api
  );

  return {
    ...favsHook,
    addUserToDefaultGroup,
    removeUserFromDefaultGroup,
    addUserToGroup,
    removeUserFromGroup,
    arrowElement,
    setArrowElement,
    styles,
    attributes,
    referenceElement,
    setReferenceElement,
    popperElement,
    setPopperElement,
    updatePopper,
    setOpen: (isOpen: React.SetStateAction<boolean>) => {
      updatePopper?.();
      favsHook.setOpen(isOpen);
    }
  };
}
